/**
 * Re-exports generated GraphQL types from codegen and provides UI-only helper
 * constants that codegen does not produce (e.g. dropdown option arrays).
 *
 * Components should import from here for convenience — the actual type
 * definitions live in `src/generated/graphql.tsx` (produced by
 * `npm run generate-graphql`).
 */
export {
  TranslationStatus,
  SortBy,
  SortOrder,
  type SearchFilters,
  type SearchSourceStringsInput,
  type SearchTranslationsInput,
  type SourceStringResult,
  type SourceStringSearchResults,
  type TranslationResult,
  type TranslationSearchResults,
} from 'src/generated/graphql';

import { TranslationStatus } from 'src/generated/graphql';
import { getTranslationStatusLabel } from 'src/common/translationStatus';

/**
 * Options for the Status filter dropdown.
 *
 * Exactly FOUR options, one per `TranslationStatus` value — there is no "Draft"
 * (an early mockup showed one; the contract has no such value).
 *
 * The option VALUE is always the GraphQL enum value (the API contract); the
 * label comes from the shared display mapping, so every status reads the same
 * here as it does in the results table (notably `IN_PROGRESS` → "In progress").
 * See `src/common/translationStatus.tsx`.
 */
export const TRANSLATION_STATUS_OPTIONS = [
  TranslationStatus.Complete,
  TranslationStatus.InProgress,
  TranslationStatus.Failed,
  TranslationStatus.Cancelled,
].map((status) => ({
  label: getTranslationStatusLabel(status),
  value: status,
}));

/*
 * NOTE: there is intentionally no static locale option list here.
 *
 * The Translated Locale filter is populated from the `listAllLocales`
 * query (`localeType: TARGET`), which the backend derives from CX Family
 * configuration and returns deduplicated and sorted. A hardcoded list would
 * silently drift from real CX-family data and offer locales that match nothing.
 */
